import decodeJwt from 'jwt-decode';

const TOKEN_LOCAL_STORAGE_KEY = 'authToken';

export function storeToken(token) {
  localStorage.setItem(TOKEN_LOCAL_STORAGE_KEY, JSON.stringify(token));
}

export function getStoredToken() {
  return JSON.parse(localStorage.getItem(TOKEN_LOCAL_STORAGE_KEY));
}

export function removeStoredToken() {
  localStorage.removeItem(TOKEN_LOCAL_STORAGE_KEY);
}

export function isValid(token) {
  try {
    const decoded = decodeJwt(token);

    return decoded.exp * 1000 - new Date().getTime();
  } catch (e) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js